var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 114,
    viewBox: "0 0 115 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_730_122)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 95,
    height: 94,
    rx: 47,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.3115 84.1865C73.1016 84.1865 85.0913 72.1968 85.0913 57.4067C85.0913 42.6167 73.1016 30.627 58.3115 30.627C43.5214 30.627 31.5317 42.6167 31.5317 57.4067C31.5317 72.1968 43.5214 84.1865 58.3115 84.1865Z",
    fill: "url(#paint0_linear_730_122)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2845 65.5967L69.4741 58.0382H62.0324V53.1354C62.0324 51.067 63.0701 49.0497 66.4032 49.0497H69.7886V42.6147C69.7886 42.6147 66.7175 42.104 63.7828 42.104C57.6512 42.104 53.6474 45.7249 53.6474 52.2773V58.0382H46.8345V65.5967H53.6474V83.8699C55.0151 84.0794 56.4144 84.1865 57.8398 84.1865C59.2653 84.1865 60.6647 84.0794 62.0324 83.8699V65.5967H68.2845Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_730_122",
    x: 0,
    y: 0,
    width: 115,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_730_122"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_730_122",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_730_122",
    x1: 58.3115,
    y1: 30.627,
    x2: 58.3115,
    y2: 84.0277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18ACFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0163E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.29c77969d7c0ed1300fcedba4bfb7257.svg";
export { ForwardRef as ReactComponent };